import { Component, OnInit, Injector } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaderResponse, HttpHeaders } from '@angular/common/http';
import { debounceTime, combineLatest, mergeMap, map, tap, withLatestFrom, filter } from 'rxjs/operators';
import { ExtendedEventBaseItem, WaHelperService } from 'world-archery-lib';
import {
  LoggedComponent, ViewDataService,
  ViewDataInterface, IFilterComboComponent,
  IFilterTextComponent, ViewDataConfigStruct,
  RankSortingTypeEnum,
  EventListLocator
} from 'world-archery-lib';
import { LoggerService } from 'world-archery-lib';
import { Observable, of, BehaviorSubject, forkJoin, merge } from 'rxjs';
import { CalendarFilterService } from '../../services/calendar-filter.service';
import { TableAbstractComponent } from '../../../../common-page-components/classes/table-abstract-component';
import { EventsStore } from '../../../../common-page-components/stores/entities-store/events-store';

@Component({
  selector: 'app-calendar-list',
  templateUrl: './calendar-list.component.html',
  styleUrls: ['./calendar-list.component.scss']
})
export class CalendarListComponent extends TableAbstractComponent implements OnInit {

  constructor(
    protected logger: LoggerService,
    protected views: ViewDataService,
    protected waHelper: WaHelperService,
    public filter_service: CalendarFilterService,
    httpSelf: HttpClient,
    injector:Injector
  ) {
    super(injector, filter_service, new EventsStore(httpSelf, waHelper, injector));
  }

  ngOnInit() {
    this.getDataStream().subscribe();
  }

  sortDate() {
    return (this.filter_service.sortLocator.sortingType as any) === 'DATE' &&
      this.filter_service.sortLocator.asc === true ? 1 :
      (this.filter_service.sortLocator.sortingType as any) === 'DATE' &&
        this.filter_service.sortLocator.asc === false ? -1 : 1
  }

  getDataStream() {
    return this.filter_service.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]),
      map(([a, b]) => a),
      filter(a => a.level !== undefined),
      map(values => {
        if (values === undefined) {
          return of([]);
        }
        //Always fixed to this number  https://app.asana.com/0/44511835353728/1116326924610580
        const params = {
          EventTypeId: 1,
          WorldRecordStatus: typeof(values.world_record) === 'number' ? values.world_record : values.world_record === true ? 1 : -1,
          WorldRankingEvent:  typeof(values.world_ranking) === 'number' ? values.world_ranking :  values.world_ranking === true ? 1 : -1,
          DivId: values.bowstyles,
          DisciplineId: values.discipline,
          Cancelled: -1,
          Detailed: 1,
          StartDate: String(new Date(values.date.begin.getTime() - values.date.begin.getTimezoneOffset() * 60000).toISOString().slice(0, 10)),
          EndDate: values.date.end ? String(new Date(values.date.end.getTime() - values.date.end.getTimezoneOffset() * 60000).toISOString().slice(0, 10)) : undefined,
          fText: values.text,
          Country: values.country,
          SortBy: values.order,
          v: 3,
          content: 'COMPETITIONS',
          LevelId: values.level.length > 0 ? values.level.filter(value => value != null).map(value => value.toString() + '').join('|') : undefined,
        }

        if (values.level == undefined) {
          values.level = [undefined as any];
        }


        return params;
      }),
      mergeMap(params=> this.model.requestData(params,this.request_more_data))
    );
  }

  get defaultValueMessage() {
    return (<IFilterComboComponent>(
      this.filter_service.filtersType[5].options
    )).options_selected_subject
      .asObservable()
      .pipe(
        // filter(category => category !== undefined)
        map(a => {
          if (a === undefined) {
            return 'adjust_parameters';
          } else {
            return '';
          }
        })
      );
  }

}
